var Ractive = require('ractive');
var component = module;

  component.exports ={
    data:function() {
      return {           
          Meta: {
            Columns: []
          },
          Row: {},
          Lng: SiteLng
        }
    }
  }

component.exports.template = {v:4,t:[{p:[1,1,0],t:7,e:"dl",m:[{n:"class",f:"row",t:13}],f:[{t:4,f:[{t:4,f:[{p:[4,3,70],t:7,e:"dt",m:[{n:"class",f:"col-sm-3",t:13}],f:[{p:[4,24,91],t:7,e:"span",m:[{n:"class",f:"text-end d-none d-sm-block",t:13}],f:[{t:3,r:".DetailCaption",p:[4,65,132]}]},{p:[4,92,159],t:7,e:"span",m:[{n:"class",f:"text-start d-block d-sm-none",t:13}],f:[{t:3,r:".DetailCaption",p:[4,135,202]}]}]}," ",{p:[5,3,238],t:7,e:"dd",m:[{n:"class",f:"col-sm-9",t:13}],f:[{t:3,x:{r:["format",".Name","Row",".Control"],s:"_0.Value(_2[_1],_3)"},p:[5,24,259]}]}],n:50,r:".DetailVisible",p:[3,3,43]}],i:"c",r:"Meta.Columns",p:[2,3,20]}]}],e:{"_0.Value(_2[_1],_3)":function (_0,_1,_2,_3){return(_0.Value(_2[_1],_3));}}};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Element/DetailsReadOnly.html
// module id = 22
// module chunks = 0